import SearchRenderer from './renderer';
import { isEntryOmitted } from '../../utils/isEntryOmitted';

export const searchPlugin = {
  beforeRender({ headerRenderers, header, params, deviceType, locale }) {
    if (isEntryOmitted(deviceType, locale)(params)) {
      return;
    }

    header.actions.children.push({
      type: 'searchRenderer',
      data: {
        label: 'Search',
        id: 'search',
        breakpoints: params.breakpoints,
        isAlwaysVisible: params.isAlwaysVisible,
        messageBusTopic: params.messageBusTopic,
      },
    });

    headerRenderers.push(SearchRenderer);
  },
};
